import { useQueryClient as n, useMutation as o } from "@tanstack/react-query";
import { deleteTrailerBookingRequest as i } from "../requests/deleteTrailerBooking.js";
const u = (e) => {
  const r = n();
  return o({
    mutationKey: ["delete-trailer-rental-booking", e],
    mutationFn: async (t) => i(t),
    onSuccess: () => {
      r.invalidateQueries({ queryKey: ["trailer-booking-information", e] });
    },
    throwOnError: !1,
    retry: !1
  });
};
export {
  u as useDeleteTrailerRentalBooking
};
